import {
  adaptLPathToApi,
  adaptLPathToStore,
  adaptLPathsToStore,
} from './adapters/lpathAdapter'

import { CONTENT } from '@/services/axios.config'
import buildParamList from './utils/build_params'
import { buildServices } from './utils/build_services'
import isEmpty from 'lodash.isempty'
import omitBy from 'lodash.omitby'

const services = [
  {
    name: 'listLPaths',
    method: 'get',
    resolver: adaptLPathsToStore,
    url: (params) =>
      `/learning-paths${buildParamList(omitBy(params, isEmpty))}`,
  },
  {
    name: 'getLPathsWithoutAdapter',
    method: 'get',
    url: (params) =>
      `/learning-paths${buildParamList(omitBy(params, isEmpty))}`,
  },
  {
    name: 'getLPath',
    method: 'get',
    url: (params) => `/learning-paths/${params.lpathId}`,
    resolver: adaptLPathToStore
  },
  {
    name: 'createLPath',
    method: 'post',
    url: () => `/learning-paths`,
    data: (params) => {
      return adaptLPathToApi(params)
    },
    resolver: adaptLPathToStore
  },
  {
    name: 'editLPath',
    method: 'put',
    url: (params) => `/learning-paths/${params.lpathId}`,
    data: (params) => {
      return adaptLPathToApi(params)
    },
    resolver: adaptLPathToStore
  }
]

export const {
  createLPath,
  editLPath,
  getLPath,
  getLPathsWithoutAdapter,
  listLPaths,
} = buildServices(CONTENT, services)
